import { useQuery } from "@tanstack/react-query";
import userGlobalFilterService from "../../../services/userService/userGlobalFilterService";
import { FieldsToFilterInterface } from "../../../models/UserModel/UserGlobalFilter";
import { CACHE_KEY_GETUSERFIELDSTOFILTER } from "../../../utils/constants";

const useGetFieldsToFilter = () =>
  useQuery<FieldsToFilterInterface, Error>({
    queryKey: [CACHE_KEY_GETUSERFIELDSTOFILTER],
    queryFn: () => userGlobalFilterService.GetFieldsToFilter(),
  });

export default useGetFieldsToFilter;
